<template>
  <el-row
    v-if="isForm && dataType === 'nullrange'"
    :gutter="20"
  >
    <el-col :xs="24" :md="12">
      <form-item
        name="start_at"
        :label="getLabelText(base, 'start_at')"
        :hasDesc="hasDesc"
        :descContent="getTransText('start_at','desc',base)"
      >
        <el-date-picker
          type="datetime"
          v-model="formData.start_at"
          @input="onInput"
          @change="onChangeStart"
          class="form-item"
          :placeholder="getTransText('start_at','placeholder',base)"
          default-time="00:00:00"
        >
        </el-date-picker>
      </form-item>
    </el-col>
    <el-col :xs="24" :md="12">
      <form-item
        name="end_at"
        :label="getLabelText(base, 'end_at')"
        :hasDesc="hasDesc"
        :descContent="getTransText('end_at','desc',base)"
      >
        <el-date-picker
          type="datetime"
          v-model="formData.end_at"
          @input="onInput"
          @change="onChangeEnd"
          class="form-item"
          :placeholder="getTransText('end_at','placeholder',base)"
          default-time="23:59:59"
        >
        </el-date-picker>
      </form-item>
    </el-col>
  </el-row>
  <form-item
    v-else-if="isForm"
    :isBindAttrs="true"
    v-bind="$attrs"
    :name="name"
    :prop="prop"
    :rules="rules"
    :label="label"
    :hasDesc="hasDesc"
    :descContent="getTransText(name,'desc',base)"
  >
    <el-row
      v-if="dataType === 'YC'"
    >
      <el-col :xs="24" :md="12">
        <el-date-picker
          v-model="val"
          @input="onInput"
          class="form-item"
          :picker-options="pickerOptions"
          type="date"
          placeholder=""
          :disabled="disabled"
          :value-format="valueFormat"
          :format="$attrs.format || 'yyyy-MM-dd'"
          :default-time="$attrs.defaultTime"
          :clearable="false"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :md="12">
        <el-select
          v-model="timeVal"
          @change="onChangeTime"
          class="form-item"
          placeholder="-"
          :disabled="disabled"
          :clearable="false"
        >
          <template slot="prefix">
            <span style="padding-left: 5px">
              <i class="el-icon-time" />
            </span>
          </template>
          <el-option
            v-for="item in inputOpts"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-badge
      v-else
      class="tz-badge"
      type="info"
      :hidden="!isShowTZ(tzLocation)"
      :value="tzValue"
    >
      <el-date-picker
        v-if="dataType === 'datetime'"
        v-model="val"
        @input="onInput"
        class="form-item"
        :picker-options="pickerOptions"
        :type="$attrs.type"
        :placeholder="placeholder"
        :disabled="disabled"
        :value-format="valueFormat"
        :format="$attrs.format || valueFormat || 'yyyy-MM-dd HH:mm:ss'"
        :default-time="$attrs.defaultTime || '00:00:00'"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="dataType === 'month'"
        v-model="val"
        @input="onInput"
        class="form-item"
        type="date"
        :picker-options="pickerOptions"
        :default-value="$attrs.defaultValue"
        :placeholder="placeholder"
        :disabled="disabled"
        format="yyyy-MM"
        value-format="yyyy-MM"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="isRange && this.dataType === 'monthrange'"
        v-model="val"
        @input="onInput"
        type="monthrange"
        :range-separator="$attrs.rangeSeparator"
        :start-placeholder="$attrs.startPlaceholder"
        :end-placeholder="$attrs.endPlaceholder"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="isRange"
        v-model="val"
        @input="onInput"
        type="datetimerange"
        :range-separator="$attrs.rangeSeparator"
        :start-placeholder="$attrs.startPlaceholder"
        :end-placeholder="$attrs.endPlaceholder"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="dataType === 'booking'"
        v-model="val"
        @input="onInput"
        class="form-item"
        :type="$attrs.type"
        :placeholder="placeholder"
        :disabled="disabled"
        :pickerOptions="pickerOptions"
        :value-format="valueFormat"
        default-time="00:00:00"
        format="yyyy-MM-dd HH:mm"
      >
      </el-date-picker>
      <date-picker
        v-else-if="dataType === 'datetime15'"
        v-model="val"
        @input="onInput"
        class="form-item"
        :type="$attrs.type"
        :placeholder="placeholder"
        :disabled="disabled"
        :value-format="valueFormat"
        default-time="00:00:00"
        format="yyyy-MM-dd HH:mm"
      >
      </date-picker>
      <el-time-select
        v-else-if="dataType === 'time15'"
        v-model="val"
        @input="onInput"
        class="form-item"
        :picker-options="time15Opt"
        :placeholder="placeholder"
        :disabled="disabled"
      >
      </el-time-select>
      <el-input
        v-else
        v-model="timeText"
        type="text"
        class="form-item"
        :placeholder="placeholder"
        readonly
        disabled
      >
      </el-input>
    </el-badge>
  </form-item>
  <el-table-column
    v-else
    v-bind="$attrs"
    align="center"
    :label="label"
    >
    <template slot-scope="scope">
      <span v-if="dataType === 'date'">
        {{ getDateText(scope.row[name]) }}
      </span>
      <el-tooltip
        v-else-if="showInColumn(scope.row)"
        class="item"
        effect="dark"
        placement="top-end"
        :open-delay="openDelay"
        >
        <div slot="content">
          <span v-if="isRange">
            <span v-if="scope.row[fieldStart] === null && scope.row[fieldEnd] === null">
              {{ $t('api.unlimited') }}
            </span>
            <span v-else-if="dataType === 'null-month-range'">
              {{ getTimeText(scope.row[fieldStart], false, $t('api.unlimited')) }}
              ~
              {{ getEndOfMonthText(scope.row[fieldEnd], false, $t('api.unlimited')) }}
            </span>
            <span v-else>
              {{ getTimeText(scope.row[fieldStart], scope.row.tz_location || true, $t('api.unlimited')) }}
              ~<br/>
              {{ getTimeText(scope.row[fieldEnd], scope.row.tz_location || true, $t('api.unlimited')) }}
            </span>
          </span>
          <span v-else>
            <span v-if="isShowTZ(scope.row.tz_location)">
              {{ $t('api.localTZ') }}:
              {{ getTimeText(scope.row[name], scope.row.tz_location) }}
              <br/>
              {{ $t('api.currentTZ') }}:
              {{ getTimeText(scope.row[name], true) }}
            </span>
            <span v-else>
              {{ $moment().format('Z') }}
            </span>
          </span>
        </div>
        <span v-if="isRange">
          <span v-if="scope.row[fieldStart] === null && scope.row[fieldEnd] === null">
            {{ $t('api.unlimited') }}
          </span>
          <span v-else-if="dataType === 'null-month-range'">
            {{ getMonthText(scope.row[fieldStart], $t('api.unlimited')) }}
            ~
            {{ getMonthText(scope.row[fieldEnd], $t('api.unlimited')) }}
          </span>
          <span v-else>
            {{ getDateText(scope.row[fieldStart], scope.row.tz_location || true, $t('api.unlimited')) }}
            ~<br/>
            {{ getDateText(scope.row[fieldEnd], scope.row.tz_location || true, $t('api.unlimited')) }}
          </span>
        </span>
        <span v-else-if="dataType === 'promo'">
          {{ getPromoDisplayTime(scope.row, name) }}
        </span>
        <span v-else>
          <span v-if="isShowTZ(scope.row.tz_location)">
            {{ $moment(scope.row[name]).tz(scope.row.tz_location).format('YYYY-MM-DD HH:mm') }}
            <small class="dark-gray">{{ $moment(scope.row[name]).tz(scope.row.tz_location).format('Z') }}</small>
          </span>
          <span v-else>
            {{ getDisplayTime(scope.row, name) }}
          </span>
        </span>
      </el-tooltip>
    </template>
  </el-table-column>
</template>

<script>

import { getEndOfMonthText, getMonthText, getDateText, getTimeText } from '@/utils/time'
import { getTransText, getLabelText } from '@/utils/i18n'
import { PromoTimeType } from '@/enums'

const defTime15Opt = {
  start: '00:00',
  step: '00:15',
  end: '23:45'
}

export default {
  name: 'time-field',
  props: {
    value: null,
    timeValue: null,
    disabled: Boolean,
    hasPlaceHolder: Boolean,
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      default: () => {}
    },
    prop: {
      type: String
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    fieldStart: {
      type: String,
      default: 'start'
    },
    fieldEnd: {
      type: String,
      default: 'end'
    },
    isForm: {
      type: Boolean,
      default: true
    },
    labelText: {
      type: String,
      default: ''
    },
    tzLocation: {
      type: String,
      default: ''
    },
    openDelay: {
      type: Number,
      default: 500
    },
    required: {
      type: Boolean,
      default: false
    },
    isShowLocalTZ: {
      type: Boolean,
      default: false
    },
    dataType: {
      type: String,
      default: 'text'
    },
    showInColumn: {
      type: Function,
      default: () => true
    },
    placeholderText: {
      type: String,
      default: null
    },
    inputOpts: {
      type: Array,
      default: () => []
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      val: this.value,
      timeVal: this.timeValue,
      startOpt: {
        disabledDate: (t) => {
          return this.$moment(t).isAfter(this.$moment(this.formData.end_at))
        }
      }
    }
  },
  mounted () {
  },
  computed: {
    valueFormat () {
      if (this.$attrs.valueFormat) {
        return this.$attrs.valueFormat
      }
      if (this.isShowLocalTZ) {
        // Need to set value-format to prevent being auto converted to the timezone of user browser
        return 'yyyy-MM-ddTHH:mm:ssZ'
      }
      return null
    },
    tzValue () {
      return this.tzLocation + ' ' + this.$moment.tz(this.tzLocation).format('Z')
    },
    isRange () {
      switch (this.dataType) {
        case 'datetimerange':
        case 'nullrange':
        case 'null-month-range':
        case 'monthrange':
        case 'daterange':
          return true
      }
      return false
    },
    time15Opt () {
      if (this.pickerOptions) {
        return this.pickerOptions
      }
      return defTime15Opt
    },
    rules: function () {
      var rules = this.$attrs.rules
      if (!rules) {
        switch (this.dataType) {
          case 'datetimerange':
            rules = [{
              type: 'array',
              required: this.required,
              validator: this.validDateRange,
              trigger: 'change'
            }]
            break
          case 'nullrange':
            rules = []
            break
          default:
            rules = [{
              required: this.required,
              message: this.getTransText(this.name, 'error', this.base),
              trigger: 'blur'
            }]
        }
      }
      return rules
    },
    label: function () {
      return this.labelText ||
        this.getLabelText(this.base, this.name)
    },
    timeText: function () {
      return this.getTimeText(this.value, this.tzLocation || true)
    },
    placeholder: function () {
      if (this.placeholderText !== null) {
        return this.placeholderText
      }
      if (!this.base) {
        return ''
      }
      if (this.disabled && !this.hasPlaceHolder) {
        return '-'
      }
      return this.getTransText(this.name, 'placeholder', this.base)
    }
  },
  methods: {
    getTimeText,
    getEndOfMonthText,
    getMonthText,
    getDateText,
    getTransText,
    getLabelText,
    onInput () {
      this.$emit('input', this.val)
      this.$emit('change')
    },
    onChangeTime (v) {
      this.$emit('changeTime', this.timeVal)
    },
    onChangeStart (v) {
      if (this.formData &&
      this.formData.end_at &&
      this.$moment(v).isAfter(this.$moment(this.formData.end_at))) {
        this.formData.end_at = null
      }
    },
    onChangeEnd (v) {
      if (this.formData &&
      this.formData.start_at &&
      this.$moment(v).isBefore(this.$moment(this.formData.start_at))) {
        this.formData.start_at = null
      }
    },
    isShowTZ (tz) {
      return this.isShowLocalTZ && tz
    },
    validRangeStart (v) {
      if (this.formData && this.formData.end_at) {
        return false
      }
      return true
    },
    validRangeEnd (v) {
      return true
    },
    validDateRange (rule, value, callback) {
      if (!this.val ||
        this.val.length !== 2 ||
        !this.val[0] ||
        !this.val[1]) {
        callback(new Error(this.getTransText('date_range', 'error', this.base)))
        return
      }
      callback()
    },
    getPromoDisplayTime (row, name) {
      if (row['time_type'] === PromoTimeType.Range) {
        return this.getTimeText(row[name])
      }

      if (name === 'start_at') {
        return this.$t('api.promo.received_wording')
      }

      switch (row['time_type']) {
        case PromoTimeType.Day:
          return this.$t('api.promo.list.time_type.wording.map.day', {n: row['duration']})
        case PromoTimeType.Month:
          return this.$t('api.promo.list.time_type.wording.map.month', {n: row['duration']})
      }
    },
    getDisplayTime (row, name) {
      return this.getTimeText(row[name]) || this.placeholderText || ''
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    },
    timeValue (newValue) {
      this.timeVal = newValue
    }
  }
}
</script>
